import { render, staticRenderFns } from "./CenterViewBehalfCreate_Ap.vue?vue&type=template&id=bbfce202&scoped=true"
import script from "./CenterViewBehalfCreate_Ap.vue?vue&type=script&lang=js"
export * from "./CenterViewBehalfCreate_Ap.vue?vue&type=script&lang=js"
import style0 from "./CenterViewBehalfCreate_Ap.vue?vue&type=style&index=0&id=bbfce202&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbfce202",
  null
  
)

export default component.exports